import React, { Component } from 'react';
import MicrolinkCard from '../controls/MicrolinkCard';

class ModalInspiration extends Component {
    constructor(props){
        super(props);
    }

    render() {
      if (!this.props.inquiry) return <div className="alert alert-danger">No Booking</div>;
      const {inquiry} = this.props;
      console.log(inquiry);
      return (
    	  <React.Fragment>
          <ul>
          {inquiry.inspiration_list.map((inspiration, index) => {
            if (inspiration.sys_media_type_id === 3 && inspiration.url !== ''){
              return (
                <li key={index}><a href={inspiration.url} target="_blank">{inspiration.url}</a> - <small>{inspiration.contents}</small></li>
              );
            }
          })}
          </ul>
        </React.Fragment>
    )
  }
}

export default ModalInspiration;


// <div className="card card-shadowed" key={index}>
//   <div className="card-body">
//     <MicrolinkCard style={{maxWidth:100+"%"}} preview={inspiration.url}/>
//   </div>
//   <footer className="card-footer flexbox">
//     <p><em>{inspiration.contents}</em></p>
//   </footer>
// </div>



// WEBPACK FOOTER //
// ./src/components/business/ModalInspiration.js